import ProductComboProductSelection from "./ProductComboGroupSelection.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils.js";

/* =============================================================================
   One group of choices inside a product combo.

   ⚠ TWO LAYOUTS, and the difference is not cosmetic.

   Under bulk pricing the groups sit TWO-UP (col-sm-6). A bulk order form
   routinely has a dozen groups, and stacking those full width turns the modal
   into a scroll marathon. Everywhere else each group gets the full row, because
   a normal combo has two or three and they read better one per line.

   The redesign originally dropped the bulk branch. Restored.
   ============================================================================= */
export default function ProductComboGroup(props) {
    const isBulkPricing = CommonUtilities.StaticFields.PriceType === 'bp8826';

    const selection =
        <ProductComboProductSelection
            key={props.productComboGroupDetails.productComboGroupID}
            productComboGroupDetails={props.productComboGroupDetails}
            groupFormData={props.groupFormData}
            groupValidationData={props.groupValidationData}
            handleProductComboGroupSelect={props.handleProductComboGroupSelect}
            addToCartError={props.addToCartError}
        />;

    const heading =
        <span className="wo-opt__name">{props.productComboGroupDetails.productComboGroupName}</span>;

    // Bulk pricing — the whole group is one half-width cell.
    if (isBulkPricing) {
        return (
            <div className="col-sm-6 wo-opt__cell">
                <div className="wo-opt__head">{heading}</div>
                {selection}
            </div>
        )
    }

    // Everything else — head and selection are siblings in the parent row.
    return (
        <>
            <div className="col-12 wo-opt__head">{heading}</div>
            {selection}
        </>
    )
}
